
import { ColumnFilter } from '../Common/ColumnFilter';
export const COLUMNS = [
	// {
	// 	Header: 'S.No.',
	// 	Footer: 'S.No.',
	// 	accessor: 'id',
	// 	Filter: ColumnFilter,
	// 	// disableFilters: true,
	// },
	{
		Header: 'Customer Name',
		Footer: 'Customer Name',
		accessor: 'cm_customer_name',
		Filter: ColumnFilter,
		// disableFilters: true,
	},
	{
		Header: 'City',
		Footer: 'City',
		accessor: 'cm_city',
		Filter: ColumnFilter,
		// disableFilters: true,
	},
	{
		Header: 'GSTIN',
		Footer: 'GSTIN',
		accessor: 'cm_gstin',
		Filter: ColumnFilter,
		// disableFilters: true,
	},
	{
		Header: 'Contact Person',
		Footer: 'Contact Person',
		accessor: 'cm_contact_person',
		Filter: ColumnFilter,
		// disableFilters: true,
	},
	{
		Header: 'Mobile Number',
		Footer: 'Mobile Number',
		accessor: 'cm_mobile_number',
		Filter: ColumnFilter,
		// disableFilters: true,
	},
	{
		Header: 'Email',
		Footer: 'Email',
		accessor: 'cm_emailid',
		Filter: ColumnFilter,
		// disableFilters: true,
	},
	{
		Header: 'Status',
		Footer: 'Status',
		accessor: 'status',
		Filter: ColumnFilter,
		// disableFilters: true,
	},
]

export const GROUPED_COLUMNS = [
]